import * as actionTypes from '../actionTypes'

const initialState = []

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_WITHOLDINGS:
      return action.payload
    case actionTypes.ADD_WITHOLDING:
      return [...state, action.payload]
    case actionTypes.EDIT_WITHOLDING:
      return state.map((item) => (item.id === action.payload.id ? action.payload : item))
    case actionTypes.DELETE_WITHOLDING:
      return state.filter((item) => item.id !== action.payload.id)
    default:
      return state
  }
}

export default reducer
